import styles from './Modals.module.css'

interface FailedExamplesModalProps {
  failedExamples: any[]
  isLoadingFailedExamples: boolean
  failedExamplesExhausted: boolean
  failedExamplesSearchInfo: string | null
  onClose: () => void
  onLoadMore: () => void
  onImageClick: (url: string) => void
  getHumanDefects: (humanResponse: any) => string
}

function FailedExamplesModal({
  failedExamples,
  isLoadingFailedExamples,
  failedExamplesExhausted,
  failedExamplesSearchInfo,
  onClose,
  onLoadMore,
  onImageClick,
  getHumanDefects,
}: FailedExamplesModalProps) {
  return (
    <div
      className={styles.failedExamplesOverlay}
      onClick={onClose}
    >
      <div
        className={styles.failedExamplesModal}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.failedExamplesHeader}>
          <h2>Failed Audit Examples</h2>
          <button
            className={styles.lightboxClose}
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <div className={styles.failedExamplesContent}>
          {failedExamplesSearchInfo && (
            <div
              style={{
                padding: '10px',
                background: 'var(--bg-secondary)',
                borderRadius: '4px',
                marginBottom: '15px',
                fontSize: '14px',
                color: 'var(--text-primary)',
              }}
            >
              ℹ️ {failedExamplesSearchInfo}
            </div>
          )}
          {failedExamples.map((example, idx) => (
            <div
              key={idx}
              className={styles.failedExampleCard}
            >
              <div className={styles.auditObjectIdLabel}>
                Audit ID:{' '}
                <span className={styles.auditObjectIdValue}>
                  {example.auditObjectId}
                </span>
              </div>
              <div className={styles.cardImagesSection}>
                {example.images &&
                  example.images.map((img: any, imgIdx: number) => (
                    <img
                      key={imgIdx}
                      src={img.url}
                      alt={img.type}
                      className={styles.cardImage}
                      onClick={() => onImageClick(img.url)}
                    />
                  ))}
              </div>
              <div className={`${styles.decisionBlock} ${styles.decisionFail}`}>
                <div className={styles.decisionHeader}>
                  <strong>Human Decision:</strong>
                  <span className={styles.decisionBadge}>FAIL</span>
                </div>
                <div className={styles.decisionDetails}>
                  <p>
                    <strong>Defects:</strong>{' '}
                    {getHumanDefects(example.humanResponse)}
                  </p>
                  {example.humanResponse?.coaching?.notes && (
                    <p>
                      <strong>Notes:</strong>{' '}
                      {example.humanResponse.coaching.notes}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.failedExamplesFooter}>
          <button
            className={styles.loadMoreButton}
            onClick={onLoadMore}
            disabled={isLoadingFailedExamples || failedExamplesExhausted}
          >
            {isLoadingFailedExamples
              ? 'Loading...'
              : failedExamplesExhausted
              ? 'No More Examples'
              : 'Load More'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default FailedExamplesModal
